module.exports = __webpack_public_path__ + "img/2.edd8838.png";